import { GlobalProvider } from "@root/context";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const DiagnosisPage = lazy(() => import("./diagnosisContent"));
const InterviewExit = lazy(() => import("./interview/exit"));
const ErrorPage = lazy(() => import("@root/error"));

export const diagnosisRoutes: RouteObject[] = [
  {
    path: "/diagnosis/:id",
    element: (
      <GlobalProvider>
        <DiagnosisPage />
      </GlobalProvider>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/candidate/:candidateId/interview-exit/:interviewExitId",
    element: (
      <GlobalProvider>
        <InterviewExit />
      </GlobalProvider>
    ),
    errorElement: <ErrorPage />,
  },
];
